import React from "react";
import { saveParc } from "../../actions/parc";
import { connect } from "react-redux";
import { faArrowLeft, faBars, faFloppyDisk } from "@fortawesome/free-solid-svg-icons";
import { tempAlWait } from "../../helpers";
import AdminHeader from "../../components/AdminHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AdminHaut from "../../components/AdminHaut";
import Alert from "../../components/Alert";

class AdminParcsAdd extends React.Component {
    state = {
        menuActive: false,
        opts: [{
            type: 'link',
            ttl: 'Retourner à la liste des parcs',
            ico: faArrowLeft,
            link: '/admin/parcs',
            action: null,
            col: null
        }],
        form: {
            parcId: '',
            name: '',
            isActive: false,
        },
        alert: {
            active: false,
            type: '',
            title: '',
            desc: ''
        }
    }

    componentDidMount() {
        document.querySelectorAll('.dispAdmin').forEach(el => {
            el.style.display = "none";
        })
        document.getElementById('page').classList.add('pageWithout');
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.redSaveParc != this.props.redSaveParc) {
            this.setState({
                alert: this.props.redSaveParc.alert
            })
        }
    }

    handleSubmit = (el) => {
        el.preventDefault();
        this.props.saveParc({
            parcId: this.state.form.parcId,
            name: this.state.form.name,
            isActive: this.state.form.isActive,
            id: null
        });
        this.setState({
            alert: tempAlWait()
        })
    }

    render() {
        return <main className={`admin ${this.state.menuActive && "admin--active"}`}>
            <AdminHeader
                handleClose={(el) => this.setState({menuActive: el})}
                active={this.state.menuActive}
                changeAlert={(el) => this.setState({alert: el})}
                idtt={this.props.idtt}
            />
            {/** Bouton menu **/}
            <button
                title="Ouvrir le menu"
                aria-label="Ouvrir le menu"
                onClick={() => this.setState({menuActive: true})}
                className="adminHdr__btnOpen"
            >
                <FontAwesomeIcon icon={faBars} />
            </button>

            {/** Header de page **/}
            <AdminHaut 
                ttl="Ajouter un parc"
                options={this.state.opts}
            />
            
            {/** Données de la page **/}
            <div className="admin__ctnr">
                {/** Formulaire **/}
                <form className="admin__form">
                    {/** Identifiant du parc **/}
                    <div className="admin__inpgrp" title="Identifiant de Queue Time" aria-label="Identifiant de Queue Time">
                        <label htmlFor="parc-id" className="admin__lab">
                            Id Queue Time *
                        </label>
                        <input
                            required
                            type="text"
                            placeholder="XXXX"
                            className="admin__input"
                            id="parc-id"
                            value={this.state.form.parcId}
                            onChange={(el) => {
                                this.setState(prevState => ({
                                    form: {
                                        ...prevState.form,
                                        parcId: el.target.value
                                    }
                                }))
                            }}
                        />
                    </div>

                    {/** Nom **/}
                    <div className="admin__inpgrp" title="Nom" aria-label="Nom">
                        <label htmlFor="parc-name" className="admin__lab">
                            Nom *
                        </label>
                        <input
                            required
                            type="text"
                            placeholder="Nom français"
                            className="admin__input"
                            id="parc-name"
                            value={this.state.form.name}
                            onChange={(el) => {
                                this.setState(prevState => ({
                                    form: {
                                        ...prevState.form,
                                        name: el.target.value
                                    }
                                }))
                            }}
                        />
                    </div>

                    {/** Est activé **/}
                    <div className="admin__inpgrp" title="Activation" aria-label="Activation">
                        <label htmlFor="parc-actif" className="admin__lab">
                            Activation
                        </label>
                        <input
                            type="checkbox"
                            className="admin__input admin__input--check"
                            id="parc-actif"
                            checked={this.state.form.isActive}
                            onChange={(el) => {
                                this.setState(prevState => ({
                                    form: {
                                        ...prevState.form,
                                        isActive: el.target.checked
                                    }
                                }))
                            }}
                        />
                    </div>

                    {/** Bouton sauvegarde **/}
                    <button
                        title="Enregistrer le parc"
                        aria-label="Enregistrer le parc"
                        className="admin__btnsave"
                        type="button"
                        onClick={(el) => this.handleSubmit(el)}
                    >
                        <FontAwesomeIcon icon={faFloppyDisk} />
                        <span className="admin__btnsavetxt">Enregistrer</span>
                    </button>
                </form>
            </div>
            <Alert alert={this.state.alert}/>
        </main>
    }
}

const mapStateToProps = state => {
    return {
        redSaveParc: state.redSaveParc
    }
}

const mapDispatchToProps = {
    saveParc
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminParcsAdd);